import Web3 from "web3";
import tourTBC from "../abis/tourTbc.json";
import { apiRequest, assetUrl as laravelAssetUrl, logoutApi, saveAuth } from "../services/api";
import { useNavigate } from "react-router-dom";

export const assetUrl = laravelAssetUrl;

const endpointMap = {
  "get-my-tour": "my-tours",
  "tours/upcoming": "upcoming-tours",
  "me/get-travelers": "me/travelers",
  "me/get-travelers/all": "me/travelers/all",
  "me/get-profile": "profile",
  "get-traveler-documents": "traveler-documents",
  "submit-travelers": "tour-documents/bulk",
  "submit-payment-travelers": "tour-passenger-payment"
};

const mapEndpoint = (path) => {
  const clean = String(path || "").replace(/^\/+/, "");
  const [pathname, query = ""] = clean.split("?");
  return (endpointMap[pathname] || pathname) + (query ? `?${query}` : "");
};

export const refreshToken = async (_token) => {
  if(_token && typeof _token === "object" && _token.token && _token.user) {
    saveAuth(_token);
  } else if(_token) {
    localStorage.setItem("token", String(_token));
  }
};

export const sendRequest = async (data, _req) => {
  const endpoint = mapEndpoint(_req);

  if(String(_req).replace(/^\/+/, "") === "get-traveler-documents") {
    return apiRequest(`${endpoint}?traveler_id=${encodeURIComponent(data.traveler_id)}`, {
      method: "GET"
    });
  }

  return apiRequest(endpoint, {
    method: "POST",
    body: JSON.stringify(data)
  });
};

export const sendPutRequest = async (data, _req) => {
  const endpoint = mapEndpoint(_req);

  return apiRequest(endpoint, {
    method: "PUT",
    body: JSON.stringify(data)
  });
};

export const authRequestNbGet = async (_req) => {
  return apiRequest(mapEndpoint(_req), { method: "GET" });
};

export const sendFileRequest = async (data, _req) => {
  const formdata = data instanceof FormData ? data : new FormData();

  if(!(data instanceof FormData)) {
    Object.entries(data).forEach(([key, value]) => formdata.append(key, value));
  }

  return apiRequest(mapEndpoint(_req), {
    method: "POST",
    body: formdata
  });
};

export const calcAgeFromDob = (rawDob) => {
  if(!rawDob) return null;

  let dob = rawDob;

  if(rawDob && typeof rawDob === "object" && rawDob.$d instanceof Date) {
    dob = rawDob.$d;
  }

  if(dob instanceof Date) {
    if(isNaN(dob.getTime())) return null;
  } else if(typeof dob === "string") {
    let s = dob.trim();

    if(!s) return null;

    const dashParts = s.split("-");
    const slashParts = s.split("/");

    if(dashParts.length === 3 && dashParts[0].length === 2) {
      const [dd, mm, yyyy] = dashParts;
      s = `${yyyy}-${mm}-${dd}`;
    } else if(slashParts.length === 3 && slashParts[0].length === 2) {
      const [dd, mm, yyyy] = slashParts;
      s = `${yyyy}-${mm}-${dd}`;
    }

    dob = new Date(s);

    if(isNaN(dob.getTime())) return null;
  } else {
    dob = new Date(dob);

    if(isNaN(dob.getTime())) return null;
  }

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();

  if(m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;

  return age;
};

export const toTitleCase = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const allLetter = (inputtxt) => {
  var letters = /^[a-zA-Z '.-]*$/;

  if(inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
};

export const onlyLetters = (inputtxt) => {
  var letters = /^[a-zA-Z]*$/;

  if(inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
};

export const alphanumeric = (inputtxt) => {
  var letters = /^[A-Z0-9_]*$/;

  if(inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
};

export const numeric = (inputtxt) => {
  var digits = /^[0-9]*$/;

  if(inputtxt.match(digits)) {
    return true;
  } else {
    return false;
  }
};

export const vpancard = (inputtxt) => {
  var letters = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;

  if(inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
};

export const vIndiaphone = (inputtxt) => {
  const mobileRegex = /^\+91[6-9]\d{9}$/;
  return mobileRegex.test(inputtxt);
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateAadhar = (inputtxt) => {
  const aadharRegex = /^\d{12}$/;
  return aadharRegex.test(inputtxt);
};

export const validatePassport = (inputtxt) => {
  if(!inputtxt || typeof inputtxt !== "string") return false;

  const str = inputtxt.trim().toUpperCase();

  const patterns = [
    /^[A-Z]{1,2}[0-9]{7,9}$/,
    /^[A-Z][0-9]{8}$/,
    /^[0-9]{8,9}$/,
    /^[A-Z]{1,3}[0-9]{6,8}$/
  ];

  return patterns.some((regex) => regex.test(str));
};

export const validateInternationalId = (inputtxt) => {
  const passportRegex = /^[A-Z][0-9]{7}$/;
  const aadharRegex = /^\d{12}$/;
  const voterIdRegex = /^[A-Z]{3}[0-9]{7}$/;
  const drivingLicenceRegex = /^[A-Z]{2}[0-9]{2}[ -]?[0-9]{6,7}$/;
  const genericIdRegex = /^[A-Z0-9\-]{6,20}$/;

  return (
    passportRegex.test(inputtxt) ||
    aadharRegex.test(inputtxt) ||
    voterIdRegex.test(inputtxt) ||
    drivingLicenceRegex.test(inputtxt) ||
    genericIdRegex.test(inputtxt)
  );
};

export const mandsCheck = (_text) => {
  var letters = /^[a-zA-Z0-9 .,@]+$/;

  if(_text.match(letters)) {
    return true;
  } else {
    return false;
  }
};


export const formatDate = (dateStr) => {
  if(!dateStr) return "";

  const d = new Date(dateStr);

  if(isNaN(d)) return dateStr;

  const options = {
    month: "long",
    year: "numeric"
  };

  return d.toLocaleDateString("en-GB", options);
};

export const formatDMy = (dateStr) => {
  if(!dateStr) return "";

  const d = new Date(dateStr);

  if(isNaN(d)) return dateStr;

  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric"
  };

  return d.toLocaleDateString("en-GB", options);
};

export const toFixed = (n, fixed) => `${n}`.match(new RegExp(`^-?\\d+(?:\.\\d{0,${fixed}})?`))[0];

export const getAvailableTravelPoints = async (userAddress) => {
  try {
    if(!userAddress) throw new Error("Wallet address is required.");

    const TBC_RPC = "https://rpc.trustbitcoin.io";
    const CONTRACT_ADDRESS = tourTBC?.CONTRACT;
    const CONTRACT_ABI = tourTBC?.ABI || tourTBC?.abi;

    const web3 = new Web3(new Web3.providers.HttpProvider(TBC_RPC));

    if(!web3.utils.isAddress(userAddress)) {
      throw new Error("Invalid wallet address.");
    }

    if(!CONTRACT_ADDRESS || !web3.utils.isAddress(CONTRACT_ADDRESS)) {
      throw new Error("Travel point contract address is invalid.");
    }

    if(!Array.isArray(CONTRACT_ABI) || CONTRACT_ABI.length === 0) {
      throw new Error("Travel point contract ABI is missing.");
    }

    const contract = new web3.eth.Contract(CONTRACT_ABI, CONTRACT_ADDRESS);
    const availablePoints = await contract.methods.getAvailablePoints(userAddress).call();
    const pointsString = String(availablePoints || "0");
    const points = Number(pointsString);

    if(!Number.isSafeInteger(points)) return pointsString;

    return points;
  } catch(error) {
    console.error("getAvailableTravelPoints error:", error);

    throw new Error(
      error?.message || "Unable to fetch travel points from TrustBitcoin blockchain."
    );
  }
};
export async function handleLogout(setUser, navigate) {

  try {
    await logoutApi();

    setUser(null);

    navigate("/login", {
      replace: true,
    });
  } catch (error) {

    setUser(null);

    navigate("/login", {
      replace: true,
    });
  }
}